/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'
import { RESERVE_TITLES } from 'helpers/i18n'
import { RESERVE_TYPES } from 'constants'

export const INDUSTRIAL_RESOURCE_DETAILS = (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_details'
        defaultMessage='Склад'
    />
)

export const INDUSTRIAL_RESOURCE_TOOLTIP = (value) => (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_tooltip_text'
        defaultMessage='Сейчас на складе {value}'
        values={{ value }}
    />
)

export const CLICK_TO_OPEN_RESOURCE_JOURNAL = (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_tooltip_hint_tracking_journal'
        defaultMessage='Нажмите, чтобы перейти к журналу учёта промресурса.'
    />
)

export const INDUSTRIAL_RESOURCE_TOOLTIP_WITH_FINES = (value) => (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_tooltip_text_with_fines'
        defaultMessage='Сейчас на складе {value} (штраф)'
        values={{ value }}
    />
)

export const INDUSTRIAL_RESOURCE_TOOLTIP_EARN_SORTIE_FORT_BATTLE = (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_tooltip_earn_sortie_fort_battle'
        defaultMessage='Добыть промресурс можно в Вылазках и Наступлениях'
    />
)

export const INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL = (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_tooltip_earn_all'
        defaultMessage='You can earn Industrial Resource in Skirmishes, Advances, and Tour Missions.'
    />
)

export const INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL_CLAN_LEGIONAIRE = (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_tooltip_earn_all_clan'
        defaultMessage='Заработать промресурс можно в Вылазках своего клана или сражаясь легионером в отрядах других кланов.' // eslint-disable-line max-len
    />
)

export const INDUSTRIAL_RESOURCE_TOOLTIP_ACTIVATE_RESERVES = (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_tooltip_activate_reserves'
        defaultMessage='Чтобы активировать резервы {battle_payments}, {tactical_training}, {additional_briefing}, {military_maneuvers} и создавать отряды для Наступлений, заработайте недостающий промресурс и погасите штраф.' // eslint-disable-line max-len
        values={{
            battle_payments: RESERVE_TITLES[RESERVE_TYPES.BATTLE_PAYMENTS],
            tactical_training: RESERVE_TITLES[RESERVE_TYPES.TACTICAL_TRAINING],
            additional_briefing: RESERVE_TITLES[RESERVE_TYPES.ADDITIONAL_BRIEFING],
            military_maneuvers: RESERVE_TITLES[RESERVE_TYPES.MILITARY_MANEUVERS],
        }}
    />
)

export const INDUSTRIAL_RESOURCE_TOOLTIP_FINE_DESCRIPTION = (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_tooltip_fine_description'
        defaultMessage='Чтобы активировать резервы и создавать отряды для Наступлений, заработайте недостающий промресурс и погасите штраф.' // eslint-disable-line max-len
    />
)




// WEBPACK FOOTER //
// ./containers/ClanPanel/components/Storage/constants.jsx